'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = OrganicSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function OrganicSvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgOrganic', width: size, height: size, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-organic' },
        _react2.default.createElement(
            'title',
            { id: 'outImgOrganic' },
            i18n.get('openrest_menubuilderv3_dishlabels_organic') || 'organic'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', { d: 'M12 23c6.0751322 0 11-4.9248678 11-11 0-6.07513225-4.9248678-11-11-11C5.92486775 1 1 5.92486775 1 12c0 6.0751322 4.92486775 11 11 11zm0 1C5.372583 24 0 18.627417 0 12S5.372583 0 12 0s12 5.372583 12 12-5.372583 12-12 12z' }),
            _react2.default.createElement('path', { d: 'M20.3796631 8.95404796L21 8.98913861l-.0109179.62762135c-.0019851.15540146-.0913136 3.83590944-2.2014516 5.80800404-.6084265.5704737-1.3826069.8522015-2.1538098.8522015-.6133891 0-1.2228081-.1854792-1.7498463-.5373883-.8496135 1.3805665-1.358786 2.8022392-1.3667263 2.8263013-.0893285.2546579-.3255528.428106-.5925458.4341215h-.0148881c-.2620303 0-.4992471-.1604144-.5975085-.406049-.0079403-.0200518-.4396948-1.0687609-1.2198305-2.2578327-.7602849.5935333-1.66151038.9053388-2.57067615.9053388-1.13744975 0-2.27192189-.4601888-3.10366961-1.3685354-2.66893748-2.9145292-2.41881764-8.03074608-2.40690717-8.24730552L3.04596114 7l.6203369.01102849c.21438844.00300777 5.26839726.12632634 7.95817806 3.06190991 1.3607711 1.486841 1.4669727 3.6945443.3821276 5.3006935.3414334.4982872.6322473.9825382.8595388 1.3996157.2719557-.58451.6431653-1.291336 1.0947706-1.9831231-.8069343-1.2813101-.6233146-3.0027571.5161203-4.0695129 2.0932648-1.95605316 5.7497787-1.77558695 5.9026297-1.76656364zm-2.4684446 5.51424514c1.2357111-1.1539811 1.6188312-3.1681845 1.7369433-4.2098755-1.042166.0421088-3.0729009.2767148-4.2947165 1.4186649-.5449039.5103183-.7166132 1.2702815-.5161203 1.9450246.4277844-.4882613.8982479-.9263932 1.4173458-1.2331857.3066946-.1824714.7017251-.0761969.8823672.2336035.1796496.3108029.0774181.7098337-.2312616.8913025-.4625232.2737071-.8883224.6887793-1.2734276 1.1620018.7027177.4461526 1.6396745.3900075 2.2788697-.2065335v-.0010026zm-6.7532357-.205531c.5091725-1.0667558.3622767-2.384159-.4813815-3.3045367-1.79351803-1.9580583-5.00735948-2.46937921-6.38103353-2.60071851.02679856 1.39861309.28882887 4.68610581 2.06944392 6.63113041 1.04514362 1.1409475 2.77414665 1.2502298 3.96420101.3027822-.61934441-.7589606-1.36771885-1.4718022-2.23420544-1.9129418-.3176125-.161417-.44664257-.5534297-.28585125-.8752611.15979879-.3208288.5488741-.4521681.86648659-.2887459.96772558.4922717 1.7955031 1.2452168 2.4823402 2.0482914z' })
        )
    );
}

OrganicSvg.displayName = 'OrganicSvg';
OrganicSvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
OrganicSvg.defaultProps = {
    size: 28,
    primaryColor: '#228f73'
};